export default "__VITE_ASSET__Csk2PkZ8__"